import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'

const helpers = createMultiStyleConfigHelpers([
  'text',
  'tag',
  'heading',
  'card',
])
export const CardConfig = helpers.defineMultiStyleConfig({
  // The styles all Cards have in common
  baseStyle: defineStyle((props) => {
    const { colorScheme: theme } = props

    return {
      heading: {
        color: `${theme}.dark`,
        fontWeight: 300,
        lineHeight: '120%',
        fontFamily: 'Lausanne',
        fontSize: { base: '1.75rem', md: '2rem' },
      },
      text: {
        color: `${theme}.dark`,
        opacity: 0.6,
        fontSize: { base: 'sm', md: 'md' },
        lineHeight: '120%',
        fontFamily: 'Lausanne',
        fontWeight: 300,
        paddingTop: '0.75rem',
        pointerEvents: 'none',
      },
      tag: {
        fontFamily: 'Cooper',
        color: `${theme}.dark`,
        fontSize: { base: '0.875rem' },
        fontWeight: 400,
        lineHeight: '120%',
        paddingBottom: '0.5rem',
      },
      card: {
        px: { base: '0.5rem', md: 4, lg: '1.5rem' },
        py: { base: '1.5rem', md: 8, lg: '2.5rem' },
        borderBottom: {
          base: '1px solid rgba(0, 0, 0, 0.20)',
        },
        boxShadow: 'none',
        transition: 'all 0.4s ease-in-out',
        _groupHover: {
          borderBottom: {
            base: '1px solid rgba(0, 0, 0, 0.20)',
            lg: '2px solid',
          },
          borderColor: {
            lg: `${theme}.aubergine`,
          },
        },
      },
    }
  }),
  variants: {
    fundsAndMadates: {
      heading: {
        fontSize: { base: '1.75rem', md: '2rem', lg: '2.5rem' },
      },
    },
    facts: defineStyle((props) => {
      const { colorScheme: theme } = props

      return {
        card: {
          backgroundColor: `${theme}.aubergine`,
          width: { base: 'full', md: '20rem', lg: '27rem' },
          height: { base: '18rem', md: '20rem', lg: '27rem' },
          opacity: 1,
          px: '2.5rem',
          _groupHover: {
            borderBottom: 'none',
          },
          borderBottom: 'none',
        },
        heading: {
          color: `${theme}.white`,
          fontSize: '1.75rem',
        },
        text: {
          color: `${theme}.white`,
          fontStyle: 'italic',
          fontSize: 'md',
          opacity: 1,
          paddingTop: '0.5rem',
        },
      }
    }),
    header: {
      heading: {
        fontSize: { base: '1rem', md: '1.5rem' },
      },
      card: { opacity: '1' },
    },
  },
})
